import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class RegisterMercadopagoVendorCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IRegisterMercadopagoVendorParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'vendor/mercadopago';
  public override setParameters(parameters: IRegisterMercadopagoVendorParameters) {
    this._commandBody = parameters;
  }
}

export interface IRegisterMercadopagoVendorParameters extends ICommandParameters {
  userId: string;
  code: string;
}
